<template>
  <a-drawer :label-col="4" :visible="open" :wrapper-col="14" width="35%" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="用户id,外键{zb_user.id}" prop="userId">
        <a-input v-model="form.userId" placeholder="请输入用户id,外键{zb_user.id}"/>
      </a-form-model-item>
      <a-form-model-item label="通知公告id,外键{sys_notice.id}" prop="noticeId">
        <a-input v-model="form.noticeId" placeholder="请输入通知公告id,外键{sys_notice.id}"/>
      </a-form-model-item>
      <a-form-model-item label="公告类型" prop="noticeType">
      </a-form-model-item>
      <a-form-model-item label="是否已读.0-否.1-是" prop="read">
        <a-input v-model="form.read" placeholder="请输入是否已读.0-否.1-是"/>
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark">
        <a-input v-model="form.remark" allow-clear placeholder="请输入内容" type="textarea"/>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button :loading="submitLoading" type="primary" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import {addMsg, getMsg, updateMsg} from '@/api/user/msg'

export default {
  name: 'CreateForm',
  props: {},
  components: {},
  data() {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        userId: null,

        noticeId: null,

        noticeType: null,

        read: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        userId: [
          {required: true, message: '用户id,外键{zb_user.id}不能为空', trigger: 'blur'}
        ],
        noticeId: [
          {required: true, message: '通知公告id,外键{sys_notice.id}不能为空', trigger: 'blur'}
        ],
        noticeType: [
          {required: true, message: '公告类型不能为空', trigger: 'change'}
        ],
        read: [
          {required: true, message: '是否已读.0-否.1-是不能为空', trigger: 'blur'}
        ]
      }
    }
  },
  filters: {},
  created() {
  },
  computed: {},
  watch: {},
  mounted() {
  },
  methods: {
    onClose() {
      this.open = false
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        noticeId: null,
        noticeType: null,
        read: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getMsg({"id": id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateMsg(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addMsg(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
